// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
import * as IntersectionObserver$Showside from "./IntersectionObserver.bs.js";
var lazyRenderRenderedIds = {};
function LazyRender(Props) {
  var trackRenderedElementsWithId = Props.trackRenderedElementsWithId;
  var thresholdsOpt = Props.thresholds;
  var rootMarginOpt = Props.rootMargin;
  var viewport = Props.viewport;
  var children = Props.children;
  var fallbackElementOpt = Props.fallbackElement;
  var thresholds = thresholdsOpt !== undefined ? thresholdsOpt : [0.0];
  var rootMargin = rootMarginOpt !== undefined ? rootMarginOpt : "0px";
  var fallbackElement = fallbackElementOpt !== undefined ? Caml_option.valFromOption(fallbackElementOpt) : null;
  var hasEverBeenVisible = trackRenderedElementsWithId !== undefined && trackRenderedElementsWithId !== "" ? Belt_Option.getWithDefault(Js_dict.get(lazyRenderRenderedIds, trackRenderedElementsWithId), false) : false;
  var match = React.useState(function () {
    return hasEverBeenVisible;
  });
  var setIsVisible = match[1];
  var isVisible = match[0];
  var ref = React.useRef(null);
  var match$1 = React.useState(function () {
    return false;
  });
  var setRefInitialized = match$1[1];
  var match$2 = IntersectionObserver$Showside.use(ref, viewport, hasEverBeenVisible, thresholds, rootMargin, undefined, undefined, undefined);
  var isIntersecting = match$2.isIntersecting;
  var setRef = function (element) {
    ref.current = element;
    Curry._1(setRefInitialized, function (param) {
      return true;
    });
  };
  React.useEffect(function () {
    if (isIntersecting && !isVisible) {
      Curry._1(setIsVisible, function (param) {
        return true;
      });
      if (trackRenderedElementsWithId !== undefined && trackRenderedElementsWithId !== "") {
        lazyRenderRenderedIds[trackRenderedElementsWithId] = true;
      }
    }
  }, [isIntersecting]);
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.callbackDomRef(setRef),
    className: CSS$Showside.prefix("hide-on-empty")
  }, isVisible ? children : fallbackElement);
}
LazyRender.displayName = "LazyRender";
var make = LazyRender;
export { make };
/* react Not a pure module */